import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = false;

const slice = createSlice({
  name: '$showHiddenLocations',
  initialState,
  reducers: {
    setShowHiddenLocations(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setShowHiddenLocations } = slice.actions;
export default slice.reducer;
